import { render, staticRenderFns } from "./suscripciones.vue?vue&type=template&id=7dab7590&"
import script from "./suscripciones.vue?vue&type=script&lang=js&"
export * from "./suscripciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports